import { IWindowOptions, Window } from "./window";

export async function askYesNo(title: string, options?: IWindowOptions) {
    const { isConfirmed } = await new Window().fire({
        title,
        icon: 'question',
        showCancelButton: true,
        showLoaderOnConfirm: true,
        allowEnterKey: true,
        ...options
    })
    return isConfirmed
}